// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2DTY4","paymentContainer":"PaymentPage_paymentContainer__13g2Z"};